import React from 'react'
import { GlobalStyles } from '@mui/material'
import { Box, Card, Typography } from '@mui/material'

import { AddableWidget, getCardCatalog } from '../../../../../../spark_libs_deprecated/feature-dashboard-widgets'
import { useFlags } from 'launchdarkly-react-client-sdk'

interface Props {
    widget: AddableWidget
}

const AddWidgetItem = ({ widget: { widgetDescription, Icon, Modal, name } }: Props): React.ReactElement => {
    const [modalOpen, setModalOpen] = React.useState(false)
    const flags = useFlags()

    const startingConfiguration = getCardCatalog(flags).cards.find(({ type }) => type === name)

    const openModal = (): void => {
        if (!startingConfiguration) {
            console.error('Missing startingConfiguration for Widget')
        }
        setModalOpen(true)
    }
    const closeModal = (): void => setModalOpen(false)

    return (
        <>
            <GlobalStyles
                styles={
                    modalOpen
                        ? {
                              // Need extra specificity
                              '.dashboard-accessory-drawer.dashboard-accessory-drawer > .MuiDrawer-paper': {
                                  overflowY: 'visible',
                                  overflowX: 'unset',
                              },
                          }
                        : undefined
                }
            />
            <Card
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    cursor: 'pointer',
                    width: '100%',
                    minWidth: '250px',
                    marginTop: '10px',
                }}
                onClick={openModal}
            >
                <Box
                    sx={{
                        backgroundColor: 'rgba(242,168,109,0.05)',
                        height: '100%',
                        minHeight: '60px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '55px',
                    }}
                >
                    {Icon && <Icon sx={{ p: 1, color: '#F2A86D' }} fontSize="large" />}
                </Box>
                <Typography variant="h6" sx={{ flexGrow: 1, mx: 1, my: 2, fontSize: '14px' }}>
                    {widgetDescription}
                </Typography>
            </Card>
            {modalOpen && startingConfiguration && (
                <Modal
                    widgetDef={startingConfiguration}
                    addingWidget
                    handleSaveConfig={closeModal}
                    handleClose={closeModal}
                    handleDeleteCard={closeModal}
                />
            )}
        </>
    )
}

export default AddWidgetItem
